
import { Message } from "element-ui";
import _request from "../common/_request";
import cache_activity from "../cache/activity";

let lib_activity = {

    module: 'NewActivity',

    info: function(activity_id, tids, callback) {
        let data = {};
        data.activity_id = activity_id;
        data.tids = tids;
        data.share_url = window.location.href;
        let params = _request._params(this.module, "info", data);
        _request._post_base(params, function (response) {

            if (response.code !== _request.success) {
              Message.info(response.info);
              return;
            }

            cache_activity.set(response.data);
              //回调数据
            if (typeof callback === 'function')
                callback(response.data)
          },0);
    },

    //裂变红包详情
    info_news: function(activity_id, tids, _appid, share_url, callback) {
        let data = {};
        data.activity_id = activity_id;
        data.tids = tids;
        data.appid = _appid;
        data.share_url = share_url;
        let params = _request._params(this.module, "info", data);
        _request._post_base(params, function (response) {

            if (response.code !== _request.success) {
                Message.info(response.info);
                return;
            }

            cache_activity.set(response.data);
            //回调数据
            if (typeof callback === 'function')
                callback(response.data)
        },0);
    },

    monitor: function (activity_id,callback) {
        let params = _request._params(this.module, "monitor", {
            activity_id: activity_id,
        });
        _request._post_base(params, function (response) {

            if (response.code !== _request.success) {
                Message.info(response.info);
                return;
            }
            //回调数据
            if (typeof callback === 'function')
                callback(response.data)
        },0);
    },

    //城市

    citys: function (callback) {
        let data = {};
        let params = _request._params('Common', 'citys', data);
        _request._post_base(params, function (response) {
            if (response.code !== _request.success)
            {
                Message.info(response.info);
                return;
            }
            //回调数据
            if (typeof callback === 'function') {
                callback(response.data)
            }
        }, 0)
    },

    //后台关联城市选择
    selectedCitys: function (activity_id, callback) {
        let data = {};
        data.activity_id = activity_id;
        let params = _request._params('Activity', 'citys', data);
        _request._post_base(params, function (response) {
            if (response.code !== _request.success)
            {
                Message.info(response.info);
                return;
            }
            //回调数据
            if (typeof callback === 'function') {
                callback(response.data)
            }
        }, 0)
    },

    //支付
    payment: function (id,tid,code,callback) {
        let params = _request._params(this.module, "pay", {
            id: id,
            tid:tid,
            code:code
        });
        _request._post_base(params, function (response) {

            if (response.code !== _request.success) {
                Message.info(response.info);
                return;
            }
            //回调数据
            if (typeof callback === 'function')
                callback(response.data)
        });
    },

    //支付成功
    pay_info: function (id,callback) {
        let params = _request._params(this.module, "pay_info", {
            id: id
        });
        _request._post_base(params, function (response) {

            if (response.code !== _request.success) {
                Message.info(response.info);
                return;
            }
            //回调数据
            if (typeof callback === 'function')
                callback(response.data)
        });
    },

    //支付宝支付
    zfb_payment: function (id,callback) {
        let params = _request._params(this.module, "alipay", {
            id: id,
        });
        _request._post_base(params, function (response) {
            console.dir(response)
            if (response.code !== _request.success) {
                Message.info(response.info);
                return;
            }
            //回调数据
            if (typeof callback === 'function')
                callback(response.data)
        });
    },

    //短信验证
    sms_code: function(mobile, callback) {
        let data = {};
        data.mobile = mobile;
        let params = _request._params(this.module, "sms_code", data);
        _request._post_base(params, function (response) {

            if (response.code !== _request.success) {
                Message.info(response.info);
                return;
            }

            //回调数据
            if (typeof callback === 'function')
                callback(response.data)
        },0);
    },

    //
    code_to_openid: function(code,_appid, callback) {
        let data = {};
        data.code = code;
        data.appid = _appid;
        let params = _request._params(this.module, "code_to_openid", data);
        _request._post_base(params, function (response) {
            callback(response)
        },0);
    },

    //
    send_redpack: function(data, callback) {
        let params = _request._params(this.module, "send_redpack", data);
        _request._post_base(params, function (response) {
            if (response.code !== _request.success) {
                Message.info(response.info);
                return;
            }

            //回调数据
            if (typeof callback === 'function')
                callback(response.data)
        },0);
    },

    //省市区
    citys_all: function (callback) {
        let data = {};
        let params = _request._params('Activity', 'citys_all', data);
        _request._post_base(params, function (response) {
            if (response.code !== _request.success)
            {
                Message.info(response.info);
                return;
            }
            //回调数据
            if (typeof callback === 'function') {
                callback(response.data)
            }
        }, 0)
    },


};
export default lib_activity
